/**
 * Extract filename from a Content-Disposition header value.
 * Returns null if the header is missing or doesn't contain a filename.
 */
const extractFilenameFromHeader = (contentDisposition: string | null): string | null => {
  if (!contentDisposition) return null;
  const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
  return match?.[1]?.trim() || null;
};

/**
 * Trigger a browser download from a Blob.
 * Filename is extracted from the Content-Disposition header.
 * The backend is the single source of truth for filenames.
 */
export const triggerBlobDownload = (
  blob: Blob,
  contentDisposition: string | null,
) => {
  const filename = extractFilenameFromHeader(contentDisposition) || 'download';
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
